var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#80cade",
    d: "M12.81 67.6a10.2 10.2 0 0 1-9.94-7c-.06-.17-.1-.33-.15-.49a10.69 10.69 0 0 1 6.92-13.04L97 17.8a11.8 11.8 0 0 1 3.19-.47 10.47 10.47 0 0 1 10.21 7.14l.13.42c1.63 5.71-2.43 10.81-7.29 12.44L16.36 67a11.3 11.3 0 0 1-3.55.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#db015c",
    d: "M27.37 110.55a10.19 10.19 0 0 1-10-6.89c-.05-.16-.1-.32-.15-.49A10.76 10.76 0 0 1 24.16 90l87.34-29.54a11.2 11.2 0 0 1 3.47-.58A10.55 10.55 0 0 1 125.15 67l.13.44a11.05 11.05 0 0 1-1.28 8.84c-1.25 1.95-5.19 3.66-5.19 3.66l-87.68 30a12 12 0 0 1-3.71.63Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a900",
    d: "M100.08 110.74a10.72 10.72 0 0 1-10.27-7.31L60.66 16.84l-.15-.49A10.74 10.74 0 0 1 81 10l29.15 86.58.08.28a10.73 10.73 0 0 1-10.17 13.89Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#41b088",
    d: "M56.75 125.33A10.73 10.73 0 0 1 46.48 118L17.33 31.43l-.15-.48a10.72 10.72 0 0 1 6.9-13.12 10.9 10.9 0 0 1 3.34-.56 10.72 10.72 0 0 1 10.27 7.31l29.14 86.59c.05.15.1.32.15.48a10.73 10.73 0 0 1-10.23 13.68"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca161a",
    d: "M85.71 91.24 106 84.29l-6.61-19.73L79 71.44Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b1d37",
    d: "m42.45 106 20.32-6.95-6.69-19.85-20.35 6.88Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#69852c",
    d: "m71.24 48.26 20.33-6.94L85 21.82l-20.36 6.82Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#118f79",
    d: "m28 63 20.3-6.91-6.65-19.75-20.36 6.82z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.41a931931a2d3b6b879cb25b8d94d517.svg";
export { ForwardRef as ReactComponent };